import React from 'react'
import style from './footer.module.scss'
const Footer = () => {
  return <div className={style.wrapper}>©</div>
}

export default Footer
